import { render, staticRenderFns } from "./FondoBrand.vue?vue&type=template&id=53cb2b07&scoped=true&"
import script from "./FondoBrand.vue?vue&type=script&lang=js&"
export * from "./FondoBrand.vue?vue&type=script&lang=js&"
import style0 from "./FondoBrand.vue?vue&type=style&index=0&id=53cb2b07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb2b07",
  null
  
)

export default component.exports